/**
 * Loads the provided `key` from either sessionStorage or process.env;
 * This allows us to override configuration in our config.js file for
 * different deployment environments, and thus implies the requested
 * config item is required -- and will throw an error if not found.
 *
 * @param key the key to look up in sessionStorage or process.env
 */
export function getConfig(key: string, defaultValue?: string): string {
  const value = sessionStorage.getItem(key) || process.env[key];

  if (value === undefined) {
    if (defaultValue === undefined) {
      throw new Error(`Required configuration "${key}" not found`);
    }
    return defaultValue;
  }

  return value;
}



// WEBPACK FOOTER //
// ./src/utils/config.ts